<template>
  <div class="h-full grid grid-rows-[auto_auto_1fr] text-[#ABABAB]">
    <ThreadsNav :show-center="false" class="w-full" show-back>
      <template #right>
        <button class="btn btn-sm rounded" @click="clickClear">
          {{ t("Buttons.clear") }}
        </button>
        <!-- <button
          v-if="
            !store.form.exampleText ||
            !store.form.description ||
            !store.form.beginning ||
            !store.form.ending
          "
          class="btn  btn-sm rounded"
          @click="clickOneStep"
        >
          一键生成
        </button> -->

        <button
          v-if="storyBookId"
          class="btn btn-primary btn-sm rounded"
          @click="clickGenerate(false)"
        >
          {{ t("Buttons.save") }}
        </button>

        <button
          class="btn btn-primary btn-sm rounded"
          @click="clickGenerate(true)"
        >
          <i class="iconify mingcute--pic-line"></i>
          {{ t(`story.generate`) }}
        </button>
      </template>
    </ThreadsNav>
    <VanTabs v-model:active="store.edit.tabType">
      <VanTab :title="t(`story.base.title`)"></VanTab>
      <VanTab :title="t(`story.style.title`)"></VanTab>
      <VanTab :title="t(`story.setting.title`)"></VanTab>
    </VanTabs>
    <div class="overflow-scroll">
      <BaseStoryEdit v-if="store.edit.tabType === 0" />
      <StyleStoryEdit v-if="store.edit.tabType === 1" />
      <SettingStoryEdit v-if="store.edit.tabType === 2" />
    </div>
  </div>
  <ModalGenerate />
  <ModalStorySelect
    v-model:show="store.edit.showSelectChapter"
    v-model:select-chapter-id="store.edit.selectChapterId"
    v-model:loading="store.edit.chapterLoading"
    @confirm="clickSelectChapter"
  />
</template>

<script lang="ts" setup>
import ThreadsNav from "../../ThreadsNav.vue";
import { ref, onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import { useStoryBook } from "@/stores/story-book";
import { useRoute, useRouter } from "vue-router";
import { StorageSet, StorageRemove, StorageGet } from "@/tools/localStorage";
import { showConfirmDialog, showFailToast, showSuccessToast } from "vant";
import api from "@/modules/api";
import { useStory } from "@/stores/story";

const { t } = useI18n();
const store = useStoryBook();
const storyStore = useStory();
const route = useRoute();
const router = useRouter();
const { id } = route.query;
const key = id ? `story-${id}` : "story";
const storyBookId = ref();

const clickSelectChapter = (story: Story) => {
  if (store.edit.selectChapterType === 0) {
    // 文风样例
    let text = story.text;
    store.edit.styleChapterId = story.id!;
    try {
      let _text = "";
      JSON.parse(text).content.forEach(
        (v: any) =>
          v.type === "paragraph" &&
          typeof v.content === "object" &&
          Array.isArray(v.content) &&
          v.content.forEach(
            (v2: any) => v2.type === "text" && (_text += v2.text + "\n\n")
          )
      );
      text = _text;
    } catch (e) {}
    store.form.exampleText = text;
  } else if (store.edit.selectChapterType === 1) {
    // 前置章节
    store.form.previousStoryId = story.id;
  }
};

const clickGenerate = async (isAutoGenerate: boolean) => {
  if (id) store.form.storyBookId = Number(id);
  if (!isAutoGenerate) {
    if (!store.form.beginning) {
      return showFailToast({ message: t("Message.completeChapterBeginning") });
    }
    if (!store.form.ending) {
      return showFailToast({ message: t("Message.completeChapterEnding") });
    }

    if (!StorageGet("know_save")) {
      try {
        await showConfirmDialog({
          title: t("ConfirmModal.promptTitle"),
          message: t("ConfirmModal.saveNotCompleteText"),
          confirmButtonText: t("Buttons.confirm"),
          cancelButtonText: t("Buttons.cancel"),
        });
        StorageSet("know_save", true);
      } catch (e) {
        // 取消
        return;
      }
    }
  }
  const res = await api.storyGenerate({ ...store.form, isAutoGenerate });
  if (res.code === 200) {
    router.back();
    if (id)
      await storyStore.getStoryListByStoryBook(
        { id } as any,
        undefined,
        undefined,
        true
      );
  }
  store.resetForm();
  StorageRemove(key);
};

let g: StoryGenerateParamsKey[] = [];
// const clickOneStep = async () => {
//   // 文风 -> 简述 -> 开头 -> 结尾

//   if (!store.form.exampleText)
//     return showFailToast({ message: "请先填写文风" });

//   autoGenerate(0);
// };

// async function autoGenerate(idx: number) {
//   const steps: StoryGenerateParamsKey[] = [
//     "description",
//     "beginning",
//     "ending",
//   ];
//   const step = steps[idx];
//   if (store.form[step]) return autoGenerate(idx + 1);
//   if (idx === 0) store.edit.tabType = 1;
//   else if (idx === 1) store.edit.tabType = 2;
//   else if (idx === 2) store.edit.tabType = 2;

//   g.push(step);
//   const params = JSON.parse(JSON.stringify(store.form));
//   params[step] += `"""请在这里补全内容"""`;
//   store.edit.showGenerateLoadingModal = true;
//   store.edit.generateLength = 0;
//   await api.storyWriteGenerate(params, callback);
//   function callback(text: string) {
//     if (typeof text === "object") {
//       // 传输完了
//       store.edit.generateLength = 0;
//       if (idx !== 2) autoGenerate(idx + 1);
//       else {
//         // loading.close();
//         store.edit.showGenerateLoadingModal = false;
//         showSuccessToast({ message: "生成内容已完成" });
//       }
//       return;
//     }
//     store.edit.generateLength += text.length;
//     store.form[step] += text as any;
//   }
// }

const clickClear = () => {
  showConfirmDialog({
    title: t("ConfirmModal.clearTitle"),
    message: t("ConfirmModal.sureClearText"),
    confirmButtonText: t("Buttons.confirm"),
    cancelButtonText: t("Buttons.cancel"),
  }).then(() => {
    store.resetForm();
    StorageRemove(key);
  });
};

let timer: any = null;
onMounted(() => {
  const { id } = route.query;
  if (id) storyBookId.value = Number(id);
  store.edit.tabType = 0;
  timer = setInterval(() => {
    const { form } = store;
    StorageSet(key, form);
  }, 1000 * 2);
});

onUnmounted(() => {
  clearInterval(timer);
});
</script>
